import React, { Component } from 'react';
import IndexPage from './pages/indexPage';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './reducers/actions.js';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router } from 'react-router-dom';
import ApiHelper from './utils/apiHelper';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appSettings: null,
      ready: false
    }
  }

  componentDidMount = () => {

    const firebaseConfig = {
      apiKey: "AIzaSyCpK1dIsH0EB77qD0cZEXlNxSWsDqjkaPc",
      authDomain: "wasteware-15409.firebaseapp.com",
      projectId: "wasteware-15409",
      storageBucket: "wasteware-15409.appspot.com",
      messagingSenderId: "143254239768",
      appId: "1:143254239768:web:24dfb8d1bf0581a559216d",
      measurementId: "G-DTW979YVLG"
    };
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);
    fetch("appSettings.json").then(
      function (res) {
        return res.json()
      }).then((data) => {
        console.log('data ', data);

        ApiHelper.appSettings = data
        this.setState({ appSettings: data })
        this.setState({ ready: true })

      }).catch(
        function (err) {
          console.log(err, ' error')
        }
      )
  }

  render() {
    return (
      <React.Fragment>
        {this.state.ready &&
          //live
          <Router basename={`${process.env.PUBLIC_URL}`}>
          {/* //DEV */}
          {/* <Router > */}
            <IndexPage {...this.props} appSettings={this.state.appSettings}></IndexPage>
          </Router>
        }
        <ToastContainer />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,

})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
})

export default compose(connect(
  mapStateToProps,
  mapDispatchToProps
))(App);

